import UserSurveyIntroPage from 'src/components/UserSurvey/UserSurveyContent/UserSurveyIntroPage';
import UserSurveyThankYouPage from 'src/components/UserSurvey/UserSurveyContent/UserSurveyThankYouPage';
import UserSurveyQuestionPage from 'src/components/UserSurvey/UserSurveyContent/UserSurveyQuestionPage';
import { UserSurveyContentProps } from 'src/components/UserSurvey/types';

export default function UserSurveyContent({
	survey,
	currentPage,
	setCurrentPage,
	closeSurvey,
}: UserSurveyContentProps) {
	if (currentPage === 0) {
		return (
			<UserSurveyIntroPage survey={survey} setCurrentPage={setCurrentPage} />
		);
	}

	if (currentPage <= survey.questions.length) {
		return (
			<UserSurveyQuestionPage
				survey={survey}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
		);
	}

	return <UserSurveyThankYouPage survey={survey} closeSurvey={closeSurvey} />;
}
